import { useEffect, useState } from 'react';
export const Delayed = ({ delayMs = 200, children }) => {
    const [timedOut, setTimedOut] = useState(delayMs <= 0);
    useEffect(() => {
        if (delayMs > 0) {
            const timer = setTimeout(() => setTimedOut(true), delayMs);
            return () => clearTimeout(timer);
        }
    }, [delayMs]);
    return timedOut ? children : null;
};
//# sourceMappingURL=delayed.js.map